import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import A from '@adsk/bim360-matrix-react-a';
import Export from '@adsk/bim360-matrix-react-assets/export.svg';

import './_NavigationPanel.scss';

class NavigationPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  getLinkAttributes(item, renderExportIcon) {
    const linkAttributes = { onClick: item.onClick };

    if (renderExportIcon || item.isExternal) {
      linkAttributes.target = '_blank';
    }
    if (!item.selected) {
      linkAttributes.href = item.link;
    }

    return linkAttributes;
  }

  _renderItem(item, index, renderExportIcon) {
    const itemLinkClasses = classNames('NavigationPanel__item-link', {
      'NavigationPanel__item-link--selected': item.selected
    });

    const linkAttributes = this.getLinkAttributes(item, renderExportIcon);

    return (
      <div className="NavigationPanel__item" key={index}>
        <A className={itemLinkClasses} {...linkAttributes}>
          {item.text}
        </A>
        {renderExportIcon ? (
          <SvgIcon className={'NavigationPanel__export-icon'} height="16" width="16">
            {Export}
          </SvgIcon>
        ) : null}
      </div>
    );
  }

  _renderSection(collection, renderExportIcon) {
    if (!collection || collection.length === 0) {
      return null;
    }

    return (
      <div>
        {collection.map((item, index) => {
          return this._renderItem(item, index, renderExportIcon);
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="NavigationPanel">
        {this._renderSection(this.props.generalLinks)}
        {this._renderSection(this.props.featureModules)}
        {this._renderSection(this.props.classicProducts, true)}
      </div>
    );
  }
}

NavigationPanel.propTypes = {
  /**
   * Links to appear at the top section of the panel. Links redirect the current page
   */
  generalLinks: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string,
      onClick: PropTypes.func,
      isExternal: PropTypes.bool
    })
  ),
  /**
   * Links to other feature modules. Links redirect the current page
   */
  featureModules: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string,
      onClick: PropTypes.func,
      selected: PropTypes.bool,
      isExternal: PropTypes.bool
    })
  ),
  /**
   * Links to classic products. Links open in a new tab
   */
  classicProducts: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string,
      onClick: PropTypes.func,
      isExternal: PropTypes.bool
    })
  )
};

export default NavigationPanel;
